import { render, staticRenderFns } from "./KDisplayGroup.vue?vue&type=template&id=10e74dd0&"
import script from "./KDisplayGroup.vue?vue&type=script&lang=js&"
export * from "./KDisplayGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports